import React from 'react';
import { connect } from 'react-redux';
import { NavLocationAreas } from '../../layout/NavLocation';
import { NavLocationSelectors } from '../../selectors/NavigationStateSelectors';
import { CompositeSessionInfoSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { Breadcrumbs } from './Breadcrumbs';

const mapStateToProps: MapStateToProps<Breadcrumbs.StateProps> = (state: AppState) => ({
  items: state.breadcrumbs,
  linkLastItem: !CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state) && NavLocationSelectors.selectNavLocation(state) === NavLocationAreas.SiteAdmin.site_users,
});

export const ConnectedBreadcrumbs: React.ComponentClass<{}> =
  connect(mapStateToProps, null)(Breadcrumbs);
